define('lib/Podio.DebugGrid',['require','underscore','jquery','lib/jquery/jquery.cssAsInteger','lib/backbone/Backbone.PodioView','lib/Podio.Logger','lib/Podio.Config','lib/Podio.Event','mousetrap'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.cssAsInteger');

  var PodioView = require('lib/backbone/Backbone.PodioView');
  var podioLogger = require('lib/Podio.Logger');
  var podioConfig = require('lib/Podio.Config');
  var podioEvent = require('lib/Podio.Event');

  var Mousetrap = require('mousetrap');

  var gridOverlay = PodioView.extend({

    initialize: function() {

      if (!_.include(['development', 'staging'], podioConfig.environment)) {
        return false;
      }

      this.elmMainGrid = $('.grid.main');
      this.elmWindow = $(window);
      this.elmDocument = $(document);
      this.id = 'debug-grid';

      this.hasRendered = false;

      if(this.elmMainGrid.length) {
        this.enableShortcuts();
      } else {
        podioLogger.log('Debug grid not intialized, because grid could not be found');
      }

      Mousetrap.bind('shift+g', this.onShortcutTriggered.bind(this));
    },

    updateGridPosition: function() {
      this.elm.css({
        transform: 'translateX(' + this.elmMainGrid.offset().left + 'px)',
        width: this.elmMainGrid.width() + this.elmMainGrid.cssAsInteger('paddingLeft')
      });

      // Override the default overlay height with the actual page height
      this.pageHeight = parseFloat(this.elmDocument.height());
      this.elm.height(this.pageHeight);
    },

    updateColumnWidths: function() {

      var elmGridColumns = this.elmMainGrid.find("[class*='grid-column-']");

      _.each(elmGridColumns, function(domColumn) {
        var elmColumn = $(domColumn);

        var elmGridColumn = this.elm.find('.column').eq(elmColumn.index());
        elmGridColumn.width(elmColumn.width());
      }, this);

    },

    render: function() {

      this.elm.attr('class', this.id);
      this.elm.prependTo($('body'));

      // Positions
      this.updateGridPosition();

      // Grid lines
      var elmFirstGridLine = $('<div />', {
        'class' : 'grid-line'
      }).appendTo(this.elm);

      var lineHeight = elmFirstGridLine.outerHeight();
      var numGridLines = Math.floor(this.pageHeight / lineHeight);
      var gridLines = '';

      if(numGridLines == Number.POSITIVE_INFINITY) {
        return;
      }

      for (var i = numGridLines - 1; i >= 0; i--) {
        gridLines += '<div class="grid-line"></div>';
      }

      this.elm.append(gridLines);

      // Columns
      var elmColumnsOverlay = $('<div />', {
        'class' : 'columns-overlay-container'
      });

      elmColumnsOverlay.appendTo(this.elm);

      elmColumnsOverlay.css({
        paddingLeft: this.elmMainGrid.cssAsInteger('paddingLeft')
      });

      var elmGridColumns = this.elmMainGrid.find("[class*='grid-column-']");

      _.each(elmGridColumns, function(domColumn) {
        var elmColumn = $(domColumn);

        var elmNewColumn = $('<div />', {
          'class': 'column',
          'width': elmColumn.width(),
          'css': {
            'marginRight' : elmColumn.cssAsInteger('paddingRight')
          }
        });

        elmNewColumn.appendTo(elmColumnsOverlay);

      }, this);


      this.hasRendered = true;

    },

    showGrid: function() {
      if(!this.hasRendered ) {
        this.render();
      }

      this.onWindowResized();
      this.elm.removeClass('hidden');

      podioEvent.bind(podioEvent.Types.resize, this.onWindowResized, this);
    },

    hideGrid: function() {
      this.elm.addClass('hidden');
      podioEvent.unbind(undefined, undefined, this);
    },

    toggleGrid: function() {
      if(this.elm.is(':visible')) {
        this.hideGrid();
      } else {
        this.showGrid();
      }
    },

    onShortcutTriggered: function(){
      this.toggleGrid();
    },

    onWindowResized: function() {
      this.updateGridPosition();
      this.updateColumnWidths();
    }

  });

  var overlay = new gridOverlay();

});

